import { DialogContent, Stack, Typography, useTheme } from "@mui/material";
import { FoodsTextInput } from "@foodpilot/foods";

type Props = {
    newComment: string;
    onChange: (value: string) => void;
    placeholder: string;
    updatedAtFormatted?: string | null;
    userName?: string;
};

export const CommentDialogContent = ({ newComment, onChange, placeholder, updatedAtFormatted, userName }: Props) => {
    const theme = useTheme();

    return (
        <DialogContent sx={{ backgroundColor: theme.palette.grey[200], padding: 0 }}>
            <Stack
                sx={{
                    padding: theme.spacing(4),
                    alignItems: "center",
                    justifyContent: "center",
                    gap: theme.spacing(1),
                    "& > *": {
                        width: "100%",
                    },
                }}
            >
                <FoodsTextInput
                    value={newComment}
                    onChange={onChange}
                    ExtraInputProps={{
                        multiline: true,
                        placeholder,
                        fullWidth: true,
                        sx: {
                            border: `solid ${theme.palette.grey[800]} ${theme.spacing(0.1)} !important`,
                            padding: theme.spacing(2),
                            minHeight: theme.spacing(30),
                            borderRadius: `${theme.spacing(1)} !important`,
                            alignItems: "flex-start",
                            "&:hover": {
                                backgroundColor: "inherit !important",
                            },
                            "& .MuiInputBase-input::placeholder": {
                                opacity: 1,
                            },
                        },
                    }}
                />

                {updatedAtFormatted && (
                    <Typography variant="small-medium" color="text.secondary" align="left" sx={{ width: "100%" }}>
                        {`${updatedAtFormatted} - [${userName}]`}
                    </Typography>
                )}
            </Stack>
        </DialogContent>
    );
};
